import { Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import useNotification from "../../hooks/useNotification";
import NotificationSnackbar from "../../components/NotificationSnackbar";
import api from "../../API/axios";

interface Props {
  consumerId: number;
  email: string;
  onSuccess: (token: string, auth: any) => void;
  onError?: (msg: string) => void;
  setState?: (state: string) => void;
}

const ConsumerTwoFactorVerify: React.FC<Props> = ({
  consumerId,
  email,
  onSuccess,
  onError,
  setState,
}) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
    const { notification, showNotification, hideNotification } =
    useNotification();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await api.post("/consumer/2fa/verify-login", {
        consumerId,
        code,
      });
      const data = res.data;
      onSuccess(data.token, data);
    } catch (err: any) {
       if (err.response?.status === 401 || err.response?.status === 400) {
      showNotification("Invalid verification code. Please try again.", "error");
      setError("Invalid verification code");
      onError && onError("Invalid verification code");
    } 
  
    else {
      const message =
        err.response?.data?.message ||
        err.message ||
        "Verification failed";

      showNotification(message, "error");
      setError(message);
      onError && onError(message);
    }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
      }}
    >
      <h3 style={{ marginBottom: 8, color: "#7a8086" }}>
        2 Factor Verification
      </h3>
      <p
        style={{
          marginBottom: 20,
          color: "#7a8086",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Your one time code has been sent to your device, and is valid for 5
        minutes.
        <br />
        Please enter the code to proceed.
      </p>
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          width: "280px",
        }}
      >
        <TextField
          id="twofa-code"
          type="text"
          label="One Time Code"
          name="twofa-code"
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ""))}
          fullWidth
          required
          autoFocus
          inputProps={{ maxLength: 6, pattern: "[0-9]*" }}
          sx={{
            width: "100%",
            marginBottom: 1.5,
          }}
        />
        <Button
          type="submit"
          variant="contained"
          size="large"
          disabled={loading || !code.trim()}
          sx={{
            width: "100%",
            backgroundColor: "var(--color-primary)",
            "&:hover": { backgroundColor: "var(--color-secondary)" },
          }}
        >
          {loading ? "Verifying..." : "Continue"}
        </Button>
        <Typography
          variant="body1"
          onClick={() => setState && setState("login")}
          sx={{
            width: "100%",
            color: "var(--color-primary)",
            textAlign: "center",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Back to login
        </Typography>
      </form>
      {error && (
        <div
          style={{
            color: "var(--color-error)",
            marginTop: 12,
            fontWeight: 500,
          }}
        >
          {error}
        </div>
      )}
        <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
      />
    </div>
  );
};

export default ConsumerTwoFactorVerify;
